import {Grid} from '@mui/material';

import Footer from '../components/footer';

function Link({children, href}) {
  return (
    <a href={href} style={{color: 'currentColor', cursor: 'pointer !important'}} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  );
}

function Item({children}) {
  return (
    <div className="privacy-policy-item" style={{color: 'rgb(201, 198, 198)', fontSize: '16px', lineHeight: '24px'}}>
      {children}
    </div>
  );
}

export default function PrivacyPolicy() {
  return (
    <Grid container>
      <div style={{width: '100%', maxWidth: '1045px', margin: '0 auto', padding: '0 20px', fontFamily: 'sans-serif', marginBottom: '40px'}}>
        <h1 style={{fontFamily: 'Lato, sans-serif', textAlign: 'center', color: 'rgb(255, 255, 255)', fontSize: '32px', margin: '40px 0'}}>POLÍTICA DE PRIVACIDADE</h1>
        <Item>
          <h3>SEÇÃO 1 - INFORMAÇÕES GERAIS</h3>
          <p>
            &nbsp;A presente Política de Privacidade contém informações sobre coleta, uso, armazenamento, tratamento e proteção dos dados pessoais dos usuários e visitantes do site
            https://www.wolfprolink.com.br/, com a finalidade de demonstrar absoluta transparência quanto ao assunto e esclarecer a todos interessados sobre os tipos de dados que são coletados, os
            motivos da coleta e a forma como os usuários podem gerenciar ou excluir as suas informações pessoais.
          </p>
          <p>
            Esta Política de Privacidade aplica-se a todos os usuários e visitantes do site https://www.wolfprolink.com.br// e integra os Termos e Condições Gerais de Uso do site Wolf Pro Link,
            doravante nominada Wolf Pro Link.
          </p>
          <p>
            O presente documento foi elaborado em conformidade com a <Link href="https://www.jusbrasil.com.br/legislacao/612902269/lei-13709-18"> Lei Geral de Proteçâo de Dados Pessoais</Link> (Lei{' '}
            <Link href="https://www.jusbrasil.com.br/legislacao/612902269/lei-13709-18">13.709</Link>
            /18), o <Link href="https://www.jusbrasil.com.br/legislacao/117197216/lei-12965-14">Marco Civil da Internet</Link> (Lei
            <Link href="https://www.jusbrasil.com.br/legislacao/117197216/lei-12965-14">12.965</Link>
            /14) (e o Regulamento da UE n. 2016/6790). Ainda, o documento poderá ser atualizado em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a consultar
            periodicamente esta seção.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 2 - COMO RECOLHEMOS OS DADOS PESSOAIS DO USUÁRIO E DO VISITANTE?</h3>
          <p>Os dados pessoais do usuário e visitante são recolhidos pela plataforma da seguinte forma:</p>
          <p>
            • &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Quando o usuário se cadastra na plataforma https://www.wolfprolink.com.br/: esses dados são os dados de identificação básicos, como e-mail, nome
            e telefone. A partir deles, podemos identificar o usuário e o visitante, além de garantir uma maior segurança e bem-estar às suas necessidade.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 3 - QUAIS DADOS PESSOAIS RECOLHEMOS SOBRE O USUÁRIO E VISITANTE?</h3>
          <p>Os dados pessoais do usuário e visitante recolhidos são os seguintes:</p>
          <p>• &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Dados para a criação da conta/perfil na plataforma e-mail, nome, e telefone.</p>
          <p>
            • &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Newsletter: o e-mail cadastrado pelo visitante que optar por se inscrever na Newsletter será coletado e armazenado até que o usuário solicite o
            descadastro.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 4 - PARA QUE FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USUÁRIO E VISITANTE?</h3>
          <p>Os dados pessoais do usuário e do visitante coletados e armazenados pela plataforma Wolf Pro Link tem por finalidade:</p>
          <p>
            • &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Bem-estar do usuário e visitante: aprimorar o produto e/ou serviço oferecido, facilitar, agilizar e cumprir os compromissos estabelecidos entre
            o usuário e a empresa, melhorar a experiência dos usuários e fornecer funcionalidades específicas a depender das características básicas do usuário.
          </p>
          <p>
            • &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Melhorias da plataforma: compreender como o usuário utiliza os serviços da plataforma, para ajudar no desenvolvimento de negócios e técnicas.
          </p>
          <p>• &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Anúncios: apresentar anúncios personalizados para o usuário com base nos dados fornecidos.</p>
          <p>
            • &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Comercial: os dados são usados para personalizar o conteúdo oferecido e gerar subsídio à plataforma para a melhora da qualidade no funcionamento
            dos serviços.
          </p>
          <p>• &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Previsão do perfil do usuário: tratamento automatizados de dados pessoais para avaliar o uso na plataforma.</p>
          <p>• &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Dados de cadastro: para permitir o acesso do usuário a determinados conteúdos da plataforma, exclusivo para usuários cadastrados</p>
          <p>• &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Dados de contrato: conferir às partes segurança jurídica e facilitar a conclusão do negócio.</p>
          <p>
            O tratamento de dados pessoais para finalidades não previstas nesta Política de Privacidade somente ocorrerá mediante comunicação prévia ao usuário, de modo que os direitos e obrigações
            aqui previstos permanecem aplicáveis.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 5 - POR QUANTO TEMPO OS DADOS PESSOAIS FICAM ARMAZENADOS?</h3>
          <p>
            Os dados pessoais do usuário e visitante são armazenados pela plataforma durante o período necessário para a prestação do serviço ou o cumprimento das finalidades previstas no presente
            documento, conforme o disposto no inciso <Link href="https://www.jusbrasil.com.br/topicos/200399061/inciso-i-do-artigo-15-da-lei-n-13709-de-14-de-agosto-de-2018">I</Link> do artigo{' '}
            <Link href="https://www.jusbrasil.com.br/topicos/200399064/artigo-15-da-lei-n-13709-de-14-de-agosto-de-2018">15</Link> da Lei{' '}
            <Link href="https://www.jusbrasil.com.br/legislacao/612902269/lei-13709-18">13.709</Link>/18.
          </p>
          <p>Os dados podem ser removidos ou anonimizados a pedido do usuário, excetuando os casos em que a lei oferecer outro tratamento.</p>
          <p>Ainda, os dados pessoais dos usuários apenas podem ser conservados após o término de seu tratamento nas seguintes hipóteses previstas no artigo 16 da referida lei:</p>
          <p>I - cumprimento de obrigação legal ou regulatória pelo controlador;</p>
          <p>II - estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;</p>
          <p>III - transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei;</p>
          <p>IV - uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados.</p>
        </Item>
        <Item>
          <h3>SEÇÃO 6 - SEGURANÇA DOS DADOS PESSOAIS ARMAZENADOS</h3>
          <p>
            A plataforma se compromete a aplicar as medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração,
            comunicação ou difusão de tais dados.
          </p>
          <p>
            Os dados relativas a cartões de crédito são criptografados usando a tecnologia "secure socket layer" (SSL) que garante a transmissão de dados de forma segura e confidencial, de modo que a
            transmissão dos dados entre o servidor e o usuário ocorre de maneira cifrada e encriptada.
          </p>
          <p>
            A plataforma não se exime de responsabilidade por culpa exclusiva de terceiro, como em caso de ataque de hackers ou crackers, ou culpa exclusiva do usuário, como no caso em que ele mesmo
            transfere seus dados a terceiros. O site se compromete a comunicar o usuário em caso de alguma violação de segurança dos seus dados pessoais.
          </p>
          <p>
            Os dados pessoais armazenados são tratados com confidencialidade, dentro dos limites legais. No entanto, podemos divulgar suas informações pessoais caso sejamos obrigados pela lei para
            fazê-lo ou se você violar nossos Termos de Serviço.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 7 - COMPARTILHAMENTO DOS DADOS</h3>
          <p>
            O compartilhamento de dados do usuário ocorre apenas com os dados referentes a publicações realizadas pelo próprio usuário, tais ações são compartilhadas publicamente com os outros
            usuários.
          </p>
          <p>
            Os dados do perfil do usuário são compartilhados publicamente em sistemas de busca e dentro da plataforma, sendo permitido ao usuário modificar tal configuração para que seu perfil não
            apareça nos resultados de busca de tais ferramentas.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 8 - OS DADOS PESSOAIS ARMAZENADOS SERÃO TRANSFERIDOS A TERCEIROS?</h3>
          <p>Os dados pessoais não podem ser compartilhados com terceiros.</p>
          <p>
            Os fornecedores podem ser localizados ou possuir instalações localizadas em países diferentes. Nessas condições, os dados pessoais transferidos podem se sujeitar às leis de jurisdições nas
            quais o fornecedor de serviço ou suas instalações estão localizados.
          </p>
          <p>Ao acessar nossos serviços e prover suas informações, você está consentindo o processamento, transferência e armazenamento desta informação em outros países.</p>
          <p>
            Ao ser redirecionado para um aplicativo ou site de terceiros, você não será mais regido por essa Política de Privacidade ou pelos Termos de Serviço da nossa plataforma. Não somos
            responsáveis pelas práticas de privacidade de outros sites e lhe incentivamos a ler as declarações de privacidade deles.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 9 – COOKIES OU DADOS DE NAVEGAÇÃO</h3>
          <p>
            Os cookies referem-se a arquivos de texto enviados pela plataforma ao computador do usuário e visitante e que nele ficam armazenados, com informações relacionadas à navegação no site. Tais
            informações são relacionadas aos dados de acesso como local e horário de acesso e são armazenadas pelo navegador do usuário e visitante para que o servidor da plataforma possa lê-las
            posteriormente a fim de personalizar os serviços da plataforma.
          </p>
          <p>
            <Link href="https://www.wolfprolink.com.br">https://www.wolfprolink.com.br</Link>
            manifesta conhecer e aceitar que pode ser utilizado um sistema de coleta de dados de navegação mediante à utilização de cookies.
          </p>
          <p>
            O cookie persistente permanece no disco rígido do usuário e visitante depois que o navegador é fechado e será usado pelo navegador em visitas subsequentes ao site. Os cookies persistentes
            podem ser removidos seguindo as instruções do seu navegador. Já o cookie de sessão é temporário e desaparece depois que o navegador é fechado. É possível redefinir seu navegador da web
            para recusar todos os cookies, porém alguns recursos da plataforma podem não funcionar corretamente se a capacidade de aceitar cookies estiver desabilitada.
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 10 - CONSENTIMENTO</h3>
          <p>Ao utilizar os serviços e fornecer as informações pessoais na plataforma, o usuário está consentindo com a presente Política de Privacidade.</p>
          <p>
            O usuário, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de cancelar seu cadastro, acessar e atualizar seus dados pessoais e garante a veracidade das informações por
            ele disponibilizadas.
          </p>
          <p>
            O usuário tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve entrar em contato através do e-mail{' '}
            <Link href="mailto:contato@wolfprolink.com.br">contato@wolfprolink.com.br</Link>
          </p>
        </Item>
        <Item>
          <h3>SEÇÃO 11 - ALTERAÇÕES PARA ESSA POLÍTICA DE PRIVACIDADE</h3>
          <p>Reservamos o direito de modificar essa Política de Privacidade a qualquer momento, então, é recomendável que o usuário e visitante revise-a com frequência.</p>
          <p>
            As alterações e esclarecimentos vão surtir efeito imediatamente após sua publicação na plataforma. Quando realizadas alterações os usuários serão notificados. Ao utilizar o serviço ou
            fornecer informações pessoais após eventuais modificações, o usuário e visitante demonstra sua concordância com as novas normas.
          </p>
          <p>Diante da fusão ou venda da plataforma à outra empresa os dados dos usuários podem ser transferidas para os novos proprietários para que a permanência dos serviços oferecidos.</p>
        </Item>
        <Item>
          <h3>SEÇÃO 12 – JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS</h3>
          <p>Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o Direito brasileiro.</p>
          <p>Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra a sede da empresa.</p>
        </Item>
      </div>
      <Footer />
    </Grid>
  );
}
